export const CLOTHING = {
  veryHot: {
    head: { text: "Wear a baseball hat" },
    body: { text: "cotton shirt" },
    hands: { text: "" },
    legs: { text: "shorts or some light pants" },
    feet: { text: "" },
    risks: { text: "Stay hydrated and apply sunscreen. Avoid extended period of time outdoors to avoid the risk of a stroke" }
  },
  hot: {
    head: { text: "Wear a baseball hat" },
    body: { text: "cotton shirt" },
    hands: { text: "" },
    legs: { text: "shorts or light pants" },
    feet: { text: "" },
    risks: { text: "Stay hydrated and apply sunscreen if you are spending an extended period of time outdoors" }
  },
  warm: {
    head: { text: "" },
    body: { text: "Wear a shirt and bring a hoodie" },
    hands: { text: "" },
    legs: { text: "to go with shorts or pants" },
    feet: { text: "" },
    risks: { text: "" }
  },
  cold: {
    head: { text: "toque or hat" },
    body: { text: "sweater" },
    hands: { text: "gloves or mittens" },
    legs: { text: "warm pants" },
    feet: { text: "insulated boots" },
    risks: { text: "" }
  },
  veryCold: {
    head: { text: "A toque or a hat" },
    body: { text: "layer up with a sweater and insulating inner layers" },
    hands: { text: "wear some gloves or mittens" },
    legs: { text: "warm pants" },
    feet: { text: "and some insulated extreme cold weather boots" },
    risks: { text: "Sustained exposure can lead to frostbite" }
  },
}